import { getParentByClass } from "../../../resources/js/helper/helper";

(function () {
  /**
   * Show / Hide controls from html-player on hover
   */
  const videoFileComponents = document.querySelectorAll(".com-mockup video");
  for (let i = 0; i < videoFileComponents.length; i++) {
    const video = videoFileComponents[i];
    const videoContainer = getParentByClass(video, "com-mockup__container");
    video.removeAttribute("controls");

    video.addEventListener("playing", function (e) {
      videoContainer.classList.add("video-playing");
      videoContainer.classList.remove("video-plaused");
    });

    video.addEventListener("pause", function (e) {
      videoContainer.classList.remove("video-playing");
      videoContainer.classList.add("video-plaused");
    });

    video.addEventListener("mouseover", function () {
      video.setAttribute("controls", "controls");
    });

    video.addEventListener("mouseout", function () {
      video.removeAttribute("controls");
    });
  }
})();
